/**
 * expose-scroll.js
 * 
 * 功能说明：
 * 为水平滚动容器添加自定义滚动条进度指示器
 * 
 * ============================================
 * 完整 HTML 示例
 * ============================================
 * 
 * <!-- 在 liquid 文件中引入脚本 -->
 * <script src="//ringconn.jp/cdn/shop/t/48/assets/expose-scroll.js?v=19410881131931062471766056126" defer></script>
 * 
 * <!-- HTML 结构 -->
 * <div class="scroll-wrapper">
 *   <!-- 滚动容器：必须设置 id="expose-scroll" -->
 *   <div class="scroll-container" id="expose-scroll">
 *     <div class="scroll-item">内容 1</div>
 *     <div class="scroll-item">内容 2</div>
 *     <div class="scroll-item">内容 3</div>
 *     <div class="scroll-item">内容 4</div>
 *     <!-- 更多滚动内容... -->
 *   </div>
 *   
 *   <!-- 自定义滚动条：必须设置 id="expose-scrollbar-fill" -->
 *   <div class="scrollbar">
 *     <div class="scrollbar-fill" id="expose-scrollbar-fill"></div>
 *   </div>
 * </div>
 * 
 * ============================================
 * 完整 CSS 示例
 * ============================================
 * 
 * .scroll-wrapper {
 *   width: 100%;
 * }
 * 
 * 
 * .scroll-container {
 *   display: flex;
 *   flex-wrap: nowrap;
 *   overflow-x: scroll;
 *   scrollbar-width: none; 
 *   -ms-overflow-style: none; 
 * }
 * 
 * .scroll-container::-webkit-scrollbar {
 *   display: none; 
 * }
 * 
 * .scroll-item {
 *   flex: 0 0 auto;
 *   width: 300px;
 *   margin-right: 20px;
 * }
 * 
 * 
 * .scrollbar {
 *   position: relative;
 *   width: 80%;
 *   height: 8px;
 *   margin: 52px auto 0;
 *   border-radius: 4px;
 *   overflow: hidden;
 *   background: #E8E8E8;
 * }
 * 
 * 
 * .scrollbar-fill {
 *   position: absolute;
 *   top: 0;
 *   left: 0;
 *   width: 0%; 
 *   height: 100%;
 *   background: linear-gradient(to bottom, 
 *     rgba(91, 163, 245, 0.95) 0%, 
 *     rgba(74, 144, 226, 1) 50%,
 *     rgba(74, 144, 226, 0.95) 100%
 *   );
 *   border-radius: 4px;
 *   transition: width 0.1s ease-out;
 * }
 * 
 * ============================================
 * 使用方法（3 步）
 * ============================================
 * 
 * 1. 在 HTML 中为滚动容器添加 id="expose-scroll"
 * 2. 添加滚动条填充元素，设置 id="expose-scrollbar-fill"
 * 3. 引入脚本文件
 * 
 * ============================================
 * 工作原理
 * ============================================
 * 
 * - 监听滚动容器的 scroll 事件
 * - 计算滚动百分比：scrollLeft / (scrollWidth - clientWidth)
 * - 动态更新滚动条填充元素的宽度
 * - 自动处理窗口大小变化
 * 
 * ============================================
 * 注意事项
 * ============================================
 * 
 * - 滚动容器必须设置 overflow-x: scroll
 * - 滚动条填充元素必须设置 position: absolute 和初始 width: 0%
 * - 建议隐藏浏览器默认滚动条
 * - ID 名称必须完全匹配：expose-scroll 和 expose-scrollbar-fill
 */

(function() {
  function initScrollbar() {
    // 查找所有滚动容器（支持多个实例）
    const scrollContainers = document.querySelectorAll('[id="expose-scroll"]');
    
    if (scrollContainers.length === 0) {
      console.warn('expose-scroll: 未找到滚动容器 #expose-scroll');
      return;
    }
    
    // 为每个滚动容器初始化滚动条
    scrollContainers.forEach((scrollContainer, index) => {
      // 查找对应的滚动条填充元素
      // 先找到最近的 section 容器（.ja-hp-9 或 .ja-hp-14）
      const sectionContainer = scrollContainer.closest('.ja-hp-9, .ja-hp-14');
      let scrollbarFill = null;
      
      if (sectionContainer) {
        // 在同一个 section 容器中查找滚动条填充元素
        scrollbarFill = sectionContainer.querySelector('[id="expose-scrollbar-fill"]');
      }
      
      // 如果没找到，尝试在父元素中查找
      if (!scrollbarFill) {
        let parent = scrollContainer.parentElement;
        while (parent && parent !== document.body) {
          scrollbarFill = parent.querySelector('[id="expose-scrollbar-fill"]');
          if (scrollbarFill) break;
          parent = parent.parentElement;
        }
      }
      
      // 如果还是没找到，使用索引匹配（作为最后的后备方案）
      if (!scrollbarFill) {
        const allScrollbarFills = document.querySelectorAll('[id="expose-scrollbar-fill"]');
        if (allScrollbarFills[index]) {
          scrollbarFill = allScrollbarFills[index];
        }
      }
      
      if (!scrollbarFill) {
        console.warn(`expose-scroll: 未找到滚动条填充元素 #expose-scrollbar-fill (实例 ${index + 1})`);
        return;
      }
      
      // 标记已初始化，避免重复初始化
      if (scrollContainer.dataset.exposeScrollInitialized) {
        return;
      }
      scrollContainer.dataset.exposeScrollInitialized = 'true';
      
      /**
       * 更新滚动条进度
       * 计算滚动百分比并更新填充元素的宽度
       */
      function updateScrollbar() {
        const scrollWidth = scrollContainer.scrollWidth;      // 内容总宽度
        const clientWidth = scrollContainer.clientWidth;       // 可见区域宽度
        const scrollLeft = scrollContainer.scrollLeft;         // 当前滚动位置
        const maxScroll = scrollWidth - clientWidth;          // 最大可滚动距离
        
        // 如果内容不需要滚动，显示 100% 填充
        if (maxScroll <= 0) {
          scrollbarFill.style.width = '100%';
          return;
        }
        
        // 计算滚动百分比并更新填充宽度
        const scrollPercentage = (scrollLeft / maxScroll) * 100;
        scrollbarFill.style.width = scrollPercentage + '%';
      }
      
      // 监听滚动事件，实时更新滚动条
      scrollContainer.addEventListener('scroll', updateScrollbar);
      
      // 监听窗口大小变化，重新计算滚动条（响应式支持）
      window.addEventListener('resize', updateScrollbar);

      // 点击滚动条跳转
      const scrollbarTrack = scrollbarFill.parentElement;
      if (scrollbarTrack) {
        scrollbarTrack.addEventListener('click', function(e) {
          const rect = scrollbarTrack.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const trackWidth = rect.width;
          const percentage = Math.min(Math.max(clickX / trackWidth, 0), 1); // 限制在 0-1 之间

          const scrollWidth = scrollContainer.scrollWidth;
          const clientWidth = scrollContainer.clientWidth;
          const maxScroll = scrollWidth - clientWidth;

          if (maxScroll > 0) {
            const targetScrollLeft = maxScroll * percentage;
            scrollContainer.scrollTo({
              left: targetScrollLeft,
              behavior: 'smooth'
            });
          }
        });
      }
      
      // 初始化：设置初始滚动条状态
      // 延迟执行，确保图片已加载
      setTimeout(updateScrollbar, 100);
    });
  }
  
  /**
   * 初始化入口
   * 确保 DOM 完全加载后再执行，避免找不到元素
   */
  if (document.readyState === 'loading') {
    // DOM 还在加载，等待 DOMContentLoaded 事件
    document.addEventListener('DOMContentLoaded', initScrollbar);
  } else {
    // DOM 已经加载完成，立即执行
    initScrollbar();
  }
  
  // 监听动态内容加载（适用于 Shopify 的 section 动态加载）
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initScrollbar);
  }
})();

